<div class="header">
  <div class="header-container">
    <h1 class="header-title-shopper">Shopper FAQ’s</h1>
    <br />
    <br />
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 1. What is ZeroPay?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            ZeroPay is a payment option that allows you to split your payments
            and pay for your shopping over 3 x Zero fee, Zero interest*
            instalments.
            <br /><br />
            The first payment is required on the day you shop, and the remaining
            two instalments will be over the next 2 paydays.
            <br /><br />
            ZeroPay is accepted at a wide range of shopping partners, simply
            look out for ZeroPay at checkout or in-store.
            <br /><br />
            *Default fees and interest apply if you miss a payment.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 2. How do I apply?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Complete the simple 4 step online application on our website:
            <a [href]="applyRedirect" class="a-link" target="_blank">
              www.zeropay.co.za/apply</a
            >
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 3. What are the qualifying
            criteria?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You need to have a valid South African ID Number, be between the
            ages of 18 and 65, earn a minimum of R5 000 a month and be a
            responsible credit user (we check your credit record).
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 4. How long does the
            application process take?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If you qualify, your approval is instant as soon as the application
            has been completed! There are no documents required for signup, so
            you can spend immediately after approval. We recommend that you do
            the application before you go shopping, just to ensure you’re ready
            to go.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 5. What is my spend limit?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You will be approved for a spend limit once you’ve completed the
            application. This spend limit is customised to each shopper and is
            based on a few factors, including your payment behaviour.
            <br /><br />
            We want you to spend as much as you want to, but your first spend is
            limited until we get to know you. If you pay your account on time,
            your spend limit can be increased. We will let you know when this
            happens. If you have missed a payment, we may also decrease your
            spending limit.
            <br /><br />
            You will be able to see your spend limit on the ZeroPay App or by
            logging in to the customer portal here:
            <a [href]="portalRedirect" class="a-link" target="_blank"
              >https://app.zeropay.co.za/#/</a
            >
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 6. How many times can I
            spend?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If you’re a first timer, you will be able to spend once until we get
            to know you. <br />
            We reward good payment behaviour – we will let you know when you’re
            free to shop again to your heart’s content and your spend limit can
            be increased. Proven good payment behaviour also means being able to
            have multiple active spends on your account at a time.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 7. What is the maximum
            amount I can spend?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            This depends on your individual assessment and approved limit.
            <br />
            You will be able to spend more than your approved spend limit, but
            your first instalment will be bigger – your spend limit will be
            split in 3 and the excess amount will be required as part of your
            first payment.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 8. How is the monthly
            instalment calculated?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Depending on the amount you spend, your instalments are calculated
            over 3 x Zero fee, Zero interest payments.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i>9. How long does it take
            before I can shop once approved?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Once you have received approval confirmation, you can shop
            immediately using ZeroPay (no waiting period).
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 10. How do I pay for my
            account?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            When you sign up, you will load your preferred bank card details –
            any Debit, Cheque or Credit card (all Visa and Mastercard’s
            accepted).
            <br /><br />
            The first collection will occur immediately at the time of the
            transaction. Subsequent monthly collections will fall on the last
            day of each month or your chosen payday.
            <br /><br />
            You can also pay your remaining instalments early via the ZeroPay
            App or customer portal. If you make a manual EFT close to the date
            of a scheduled collection, the scheduled collection might still go
            off your card if the manual payment has not been allocated to your
            account yet.
            <br /><br />
            Ensure your payments are up to date in order not to pay the
            penalty/default fee and interest!
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 11. Why wasn’t my
            application approved - how do you determine if I qualify?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            To pay using ZeroPay, there are a few minimum qualifying criteria
            that you need to meet before we can grant you credit. If you were
            not approved, it may be because you have a poor credit history or no
            history at all.
            <br /><br />
            Our system conducts an assessment and based on this information, we
            will determine whether we can grant you credit and how much. We’re
            all about granting you credit responsibly and want to make sure
            you’re geared to make your payments.
            <br /><br />
            If you would like to know why you were declined, contact us on
            <a class="a-link" href="mailto:support@zeropay.co.za"
              >support&#64;zeropay.co.za.</a
            >
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 12. How do I shop online?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Simply select ZeroPay at checkout.
            <br /><br />
            If you’re a first timer, you will be able to complete your account
            profile during the check-out process. Zero hassles!
            <br /><br />
            If you’re an existing ZeroPay shopper, simply check your details and
            complete your order on check-out.
            <br /><br />
            A reminder that your first instalment is due on the day you spend
            for the order to be successful.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i>13. How do I shop in-store?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Simply show your ID number at till point and follow the prompts for
            the store to process the transaction on your account.
            <br /><br />
            A reminder that your first instalment is due on the day you spend
            for the order to be successful.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 14. I am under debt review,
            can I qualify?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Unfortunately not, you are however welcome to apply once you have
            completed your debt review process.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 15. Are payments really
            interest and fee free?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Yes - it's in our name! You will pay Zero fees and Zero interest
            when you shop (but only if you pay on time).
            <br /><br />
            If you miss a scheduled payment, we will unfortunately add a penalty
            fee and interest. A failure fee of R125 is charged if the payment is
            not resolved within 24 hours. Further default fees apply for every
            week that the unpaid amount remains outstanding. Your account will
            be disabled, and future spend limit reduced.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 16. Is my information safe?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Rest assured; we adhere to the strictest of privacy protection
            policies. See our Privacy Policy here.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 17. Is it safe to use
            ZeroPay?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Yes! All payments are processed through state-of-the-art,
            PCI-compliant payment systems that ensure the security of your
            payments.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 18. Are my payment details
            safe?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Absolutely. Our website is SSL-secure and we don’t store your card
            details. All payments are handled by a secure, PCI-compliant, South
            African-based payment gateway.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 19. What happens if I
            cancel my shopping order?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Once your order has been cancelled, the shopping partner will
            request for the amount to be refunded on ZeroPay. You will receive
            correspondence once this has been done.
            <br /><br />
            Now you just need to let us know how you want to be refunded -
            directly into your back account or the card you have loaded.
            <br /><br />
            Once you’ve let us know, we will process the refund. Don’t stress,
            this can take some time, but we will work to get it back to you
            soonest! If you have any questions please get in touch with us!
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 20. There’s a problem with
            my order, can you help?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We unfortunately do not have any control over our spend partners and
            their delivery policies. If there are any issues, please contact the
            spend partner directly and we will try our best to help where we
            can. You are still liable for the payments, so make sure you stay up
            to date.
            <br /><br />
            If you cannot get a hold of the partner, send us an email at
            <a class="a-link" href="mailto:support@zeropay.co.za"
              >support&#64;zeropayco.za</a
            >
            with your order confirmation number and we will try to contact the
            merchant to check the status of your order. We will let you know as
            soon as we have heard back from them.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 21. My card is lost/ has
            expired. Can I change the card that I use to make payments?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Yes! You can change your card details by logging into your ZeroPay
            App or the customer portal.
            <br /><br />
            Follow these steps to change your card details:
          </p>
          <ul>
            <li>Log in to the ZeroPay App or customer portal.</li>
            <li>
              Click on the tile that has your current card details are shown.
            </li>
            <li>
              Wait for the payment screen to load via our secured payment
              gateway.
            </li>
            <li>Complete the fields to capture your new card details.</li>
            <li>
              This card will automatically be loaded as your default card for
              all future payments on both existing transaction payment plans and
              new purchases.
            </li>
          </ul>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 22. How do I pay the next
            instalment before the due date, or pay my outstanding balance in
            full?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            <li>Log in to the ZeroPay App or customer portal.</li>
            <li>Click on the Next Instalment tile.</li>
            <li>Click on Pay Now.</li>
          </ul>
          <p>OR</p>
          <ul>
            <li>Log in to the ZeroPay App or customer portal.</li>
            <li>Click on the chosen order / spend.</li>
            <li>Click on Pay Now.</li>
            <li>
              Repeat for any outstanding payments for the chosen order / spend.
            </li>
          </ul>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 23. Which cards does
            ZeroPay accept?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can use any Visa or Mastercard card (debit, credit, or cheque).
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 24. I cannot add my card
            details / my instalment payment failed on my card, why?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If you’re unable to add your card or the instalment failed, there
            are a few possible reasons for this. <br />
            Unfortunately, they are usually specifically related to the card and
            are outside of our control.
            <br /><br />
            Some of the reasons may include:
          </p>
          <ol>
            <li>
              You’re trying to load an American Express card (not Visa or
              Mastercard).
            </li>
            <li>You’ve entered your card details incorrectly.</li>
            <li>Your card has expired.</li>
            <li>
              Your bank’s risk system has declined the transaction as they
              cannot identify us. This is a common reason for failed instalment
              payments. It’s a mechanism designed by banks to protect their
              clients from fraud.
            </li>
            <li>There are insufficient funds in your account.</li>
            <li>Your bank card is not enabled for online transactions.</li>
            <li>Your online spend limit is set to a low amount.</li>
            <li>
              Your bank’s system may not be running debit orders correctly.
            </li>
          </ol>
          <p>
            We are unfortunately unable to resolve this on your behalf and you
            will need to contact your bank and inform them that the instalment
            debits are legitimate and request them to lift any holds there might
            be in place. This will ensure that your instalment payments are
            processed by the due date.
            <br /><br />
            In the interim, you will be able to pay your instalments manually,
            plesae contact us on
            <a class="a-link" href="mailto:support@zeropay.co.za"
              >support&#64;zeropay.co.za</a
            >
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 25. My OTP (One Time Pin)
            hasn’t been delivered?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            First, try the Resend OTP button on the OTP screen.
            <br /><br />
            If this doesn’t work, it might be because of one of the following
            reasons:
          </p>
          <ul>
            <li>
              Your cellphone number that we have listed is different to the cell
              phone number that you’re using.
            </li>
            <li>
              Restart your phone. It may be best to begin the process from
              scratch. Follow the steps until you reach the OTP page again.
            </li>
            <li>
              If you are still not receiving an OTP, then check with your Mobile
              Network Provider to see if your number is blocked from receiving
              SMSs from certain local and overseas numbers. A common problem is
              that, if you have ported your number from one network to another,
              some SMSs are automatically blocked.
            </li>
          </ul>
          <p>
            If none of the above helped please email us at
            <a class="a-link" href="mailto:support@zeropay.co.za"
              >support&#64;zeropay.co.za</a
            >
            and we will assist you further.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 26. Can I change my payment
            date?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Yes, you can change your elected payday on the ZeroPay App or
            customer portal a maximum once per month. The date for future
            instalments will be updated, so for example if the next instalment
            date is the 31st, and the current date is the 26th, and the payday
            is changed to the 25th, then the next instalment will still be the
            31st. So only if the payday is the next day or beyond, will it
            update the instalment schedule for the next instalments.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4 class="header-class">
            <i class="fas fa-xs fa-info-circle"></i> 27. Where can I pay using
            ZeroPay?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We’ve got thousands of online and in-store partners all over South
            Africa! Check out our Where to Shop page on the ZeroPay website and
            app!
          </p>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="content">
      <br />
      <br />
      <br />
      <mat-divider></mat-divider>
      <br />
      <br />
      <br />
      <h1 class="header-title-shopper-content">
        Didn’t find the answer you were looking for?
      </h1>
      <br />
      <button mat-stroked-button class="btn-action" (click)="showContact()">
        CONTACT US
      </button>
    </div>
  </div>
</div>
